import { useParams } from "react-router-dom";
import { fetchWorkOrderPaymetDetails } from "../../services/api/workOrder";
import { useQuery } from "@tanstack/react-query";
import { CurrencySymbol } from "../../utils/enum";

const RateCard = () => {
  const { id } = useParams();

  const {
    isLoading,
    error,
    data: workOrderPaymentData,
  } = useQuery({
    queryKey: ["workOrderPayment"],
    queryFn: () => fetchWorkOrderPaymetDetails(id),
    enabled: !!id,
  });

  const payment = workOrderPaymentData?.data?.engineerRates;
  const paymentType = workOrderPaymentData?.data?.engineerRates?.paymentType;

  return (
    <div className="shadow-md rounded-md py-3 px-4  h-full min-h-24  w-full bg-white">
      <div className="flex">
        <i className="fa-solid fa-coins  text-3xl text-primary"></i>
        <div className="ml-2 mt-1">
          <p className="font-normal text-dark text-sm">Rate:</p>

          {(paymentType === "HOURLY" || paymentType === "FTH") && (
            <p className="text-primary ">
              Hourly @ {CurrencySymbol[payment?.currency] || ""} {payment?.hourlyRate?.toFixed(2)}
              {payment?.minimumHours > 0 &&
                ` (min ${payment?.minimumHours}
              hrs)`}
            </p>
          )}
          {paymentType === "HALF_DAY" && (
            <p className="text-primary ">
              Half Day @ {CurrencySymbol[payment?.currency] || ""}{" "}
              {payment?.halfDayRate?.toFixed(2)} & Additional hrs @{" "}
              {CurrencySymbol[payment?.currency]} {payment?.hourlyRate?.toFixed(2)}
            </p>
          )}
          {paymentType === "FULL_DAY" && (
            <p className="text-primary ">
              Full Day @ {CurrencySymbol[payment?.currency] || ""}{" "}
              {payment?.fullDayRate?.toFixed(2)}
            </p>
          )}
          {paymentType === "FIXED" && (
            <p className="text-primary ">
              {CurrencySymbol[payment?.currency] || ""} {payment?.fixedAmount?.toFixed(2)}
            </p>
          )}
          {payment?.expenses && payment?.expenses.length > 0 && (
            <p className="text-primary ">
              Expense {CurrencySymbol[payment?.currency] || ""}{" "}
              {payment?.totalExpenseCost?.toFixed(2)}
            </p>
          )}
          {payment?.totalWorkOrderCost > 0 && (
            <p className="text-primary ">
              Estimated Payment = {CurrencySymbol[payment?.currency] || ""}{" "}
              {payment?.totalWorkOrderCost?.toFixed(2)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RateCard;
